import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "base-checkbox__label" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["id", "checked"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "base-checkbox__additional-content"
}

import Modal from '@components/Modal/Modal.vue';
import type { CheckboxProps } from './CheckBoxProps'; // Måste importera för vue-kompileringen


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseCheckbox',
  inheritAttrs: false,
},
  __name: 'BaseCheckbox',
  props: {
    id: {},
    label: { default: '' },
    checkboxLabel: { default: '' },
    inputType: { default: '' },
    infoHeading: { default: '' },
    infoContent: { default: '' },
    modelValue: { type: Boolean, default: false },
    rootClassModifier: { default: '' },
    checkboxClassModifier: { default: '' },
    isInvalid: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit;

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-checkbox", __props.rootClassModifier])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass(['label', { 'label--checkbox': __props.inputType === 'checkbox' }])
          }, _toDisplayString(__props.label), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      (__props.infoHeading || __props.infoContent)
        ? (_openBlock(), _createBlock(Modal, {
            key: 1,
            heading: __props.infoHeading,
            content: __props.infoContent
          }, {
            link: _withCtx(({ clicked }) => [
              _createElementVNode("button", {
                class: "info-icon",
                onClick: clicked
              }, "?", 8 /* PROPS */, _hoisted_2)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["heading", "content"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["base-checkbox__checkbox", __props.checkboxClassModifier])
    }, [
      _createElementVNode("input", _mergeProps({
        id: __props.id,
        type: "checkbox"
      }, _ctx.$attrs, {
        checked: __props.modelValue,
        class: { 'base-checkbox__checkbox--invalid': __props.isInvalid },
        onChange: onChange
      }), null, 16 /* FULL_PROPS */, _hoisted_3),
      _createElementVNode("label", { for: __props.id }, _toDisplayString(__props.checkboxLabel), 9 /* TEXT, PROPS */, _hoisted_4)
    ], 2 /* CLASS */),
    (_ctx.$slots.additionalContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "additionalContent")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})